module.exports = __webpack_public_path__ + "img/art1.f980aefd.jpg";